import { Typography } from '@mui/material';

const EmptyView = () => {
  return (
    <Typography
      sx={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Select an item to view details
    </Typography>
  );
};

export default EmptyView;
